import ClassDivsion from './ClassDivsionSelector'
import {Field, FieldProps} from 'formik'
import StudentSelector from './StudentSelector'
import ToggleSection from './ToggleSelection'
import {ReceiverType} from '../types'

function RecipientTypeSelection() {
  return (
    <div className="pb-4 ">
      <Field name="receiverType">
        {({
          field,
          form: {setFieldValue, setFieldTouched, setFieldError, values, errors},
        }: FieldProps<string>) => {
          const resetFieldsForToggle = (type: ReceiverType) => {
            setFieldValue('receiverType', type, false)
            setFieldValue('class_Name', '', false)
            setFieldValue('divisionName', '', false)
            setFieldError('receiverType', undefined)
            setFieldError('class_Name', undefined)
            setFieldError('divisionName', undefined)
            setFieldTouched('class_Name', false, false)
            setFieldTouched('divisionName', false, false)

            if (type === 'standard') {
              setFieldValue('studentIds', [], false)
              setFieldError('studentIds', undefined)
              setFieldTouched('studentIds', false, false)
            }
          }
          return (
            <>
              <div className={'fs-5 text-gray-600'}>Choose Recipients</div>
              <div className="d-flex flex-column gap-5 mt-5">
                <ToggleSection
                  value="all"
                  field={field}
                  resetFieldsForToggle={resetFieldsForToggle}
                  id="all"
                  label="Choose All Students"
                >
                  <div className="text-center text-muted">
                    Notification will be sent to all Students
                  </div>
                </ToggleSection>
                <ToggleSection
                  value="standard"
                  field={field}
                  resetFieldsForToggle={resetFieldsForToggle}
                  id="standard"
                  label="Choose Class / Division"
                >
                  <ClassDivsion />
                </ToggleSection>
                <ToggleSection
                  value="specific"
                  field={field}
                  resetFieldsForToggle={resetFieldsForToggle}
                  id="specific"
                  label="Choose Specific Students"
                >
                  <StudentSelector
                    selectedClass={values.class_Name}
                    selectedDivision={values.divisionName}
                  />
                </ToggleSection>
              </div>
            </>
          )
        }}
      </Field>
    </div>
  )
}

export default RecipientTypeSelection
